import { QuoteAddon } from '@lockton-apps/shared/interfaces';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { AvatarModule } from '@lockton-apps/shared/ui/lui';
import { JoinPipe } from '@lockton-apps/shared/util/ng-lodash';

import { DynamicTableColumnTemplate } from '../column-template.directive';
import { MatTooltipModule } from '@angular/material/tooltip';
import { has, transform } from 'lodash';
import { CobMetaService } from '@lockton-apps/shared/util/constants';

@Component({
  selector: 'la-cob-title',
  imports: [
    CommonModule,
    AvatarModule,
    MatIconModule,
    MatTooltipModule,
    JoinPipe,
  ],
  templateUrl: './additional-requests.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdditionalRequestsComponent
  extends DynamicTableColumnTemplate<object>
  implements OnChanges
{
  additionalRequestsPrefix = $localize`Offline quote required for: `;

  additionalCobTitles!: string[];

  constructor(private cobMetaService: CobMetaService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entity']) {
      if (this.isQuoteWithAddons(this.entity)) {
        this.additionalCobTitles = transform(
          this.entity.addons,
          (result, { classOfBusinessId }) => {
            const addon =
              this.cobMetaService.getClassOfBusinessMeta(classOfBusinessId);

            if (addon?.offline) {
              result.push(addon.title);
            }
          }
        );
      }
    }
  }

  isQuoteWithAddons(entity: unknown): entity is { addons: QuoteAddon[] } {
    return has(entity, 'addons');
  }
}
